const PARAM_PREFIX = ':';
const OPTIONAL_SUFFIX = '?';

export const getSegmentName = (path: string): string => {
  const param =
    path.split('/').find((part) => part.startsWith(PARAM_PREFIX)) ?? '';

  const name = param.slice(PARAM_PREFIX.length);

  return name.endsWith(OPTIONAL_SUFFIX)
    ? name.slice(0, -OPTIONAL_SUFFIX.length)
    : name;
};
